<template>
  <div class="watchSet">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="测试环境地址:">
          <el-input v-model="form.testBaseUrl" disabled></el-input>
        </el-form-item>
        <el-form-item label="生产环境地址:" style="margin-bottom: 5px">
          <el-input v-model="form.proBaseUrl" disabled></el-input>
        </el-form-item>
        <div class="flex-row-start-center mgt-22" style="padding-left: 120px">
          <div style="text-align: center;">备注: 所有的接口请求,</div>
            <span class="red">请务必以 / 结尾</span> ,如请求token时,接口为
            {base_url}/v1/account/auth-token/,
            <span class="red">必须是以 / 结尾</span>。
        </div>
        <el-form-item label="Secret" required style="margin-bottom: 5px">
          <el-input v-model="form.app_secret"></el-input>
        </el-form-item>
        <div class="flex-row-start-center mgt-22" style="padding-left: 120px">
          <div style="text-align: center;">备注: 获取secret请登录后台,在</div>
          <span class="red">企业设置</span>-><span class="red">密钥管理</span> 获取,不懂可以看下图片链接
          <a href="https://www.youinsh.com/doc/apass-api.html#%E8%8E%B7%E5%8F%96token" target="_blank">https://www.youinsh.com/doc/apass-api.html#%E8%8E%B7%E5%8F%96token</a>
        </div>
        <el-form-item label="选择环境">
          <el-radio-group v-model="form.base_url" @change="changeBaseUrl">
            <el-radio :label="1">测试环境</el-radio>
            <el-radio :label="2">生产环境</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="mgt-22" style="width:100%;height:1px;border-bottom:1px solid #dedede"></div>
        <el-form-item label="user_id" required>
          <el-input v-model="form.user_id" placeholder="请输入第三方的user_id,而不是本直播平台的user_id" @change="changeUserId"></el-input>
        </el-form-item>
        <el-form-item label="auth_token" required style="margin-bottom: 5px">
          <el-input v-model="form.auth_token" disabled></el-input>
        </el-form-item>
        <div class="flex-row-start-center">
          <div style="text-align: left;margin-left: 120px">备注:
            <span class="red"> md5(secret+当前日期+userid),</span>
            如今天 2022.4.19,userid为23981,secret为qwue23fufeaf32eert,则计算md5(qwue23fufeaf32eert2022041923981)=2f46e43d2defab58cd7c61352b96af40,可以在<a href="http://www.ip33.com/md5.html" target="_blank">http://www.ip33.com/md5.html</a>进行在线验算
          </div>
        </div>
        <div class="red" style="text-align: left;margin-left: 120px;margin-bottom: 10px">注意: 通过前端操作md5来计算有风险,容易暴露auth_token和Secret,尽量通过后端来处理计算这个auth_token,这里只是为了演示比较方便</div>
        <div class="flex-row-start-start mgt-22">
          <div style="text-align: left;margin-left: 120px;padding-top: 10px;">代码片段: </div>
          <div class="token_code">
              <div>this.form.app_secret: <span class="red">{{form.app_secret}} </span></div>
              <div style="margin: 10px 0">nowData: <span class="red">{{time}}</span></div>
              <div>this.form.user_id: <span class="red">{{form.user_id}}</span></div>
              <div style="margin: 10px 0">
                this.form.auth_token = this.$md5(<span class="red">this.form.app_secret</span>+<span class="red">nowData</span>+<span class="red">this.form.user_id</span>  );
              </div>
              <span class="red">注意:</span>  this.$md5  这个是 vue js-md5 插件
          </div>
        </div>
        <el-form-item label="nick_name" required>
          <el-input v-model="form.nick_name" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="head_image" required style="margin-bottom: 5px">
          <el-input v-model="form.head_image" placeholder="请输入头像"></el-input>
        </el-form-item>
        <div class="flex-row-start-center mgt-22">
          <div style="text-align: left;margin-left: 120px">备注: 头像,https地址,且需要支持跨域访问</div>
        </div>
        <el-form-item label="play_mode" required style="margin-bottom: 5px">
          <el-radio-group v-model="form.play_mode">
            <el-radio :label="1">竖屏 </el-radio>
            <el-radio :label="2">横屏</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="flex-row-start-center mgt-22">
          <div style="text-align: left;margin-left: 120px">备注: 1竖屏 ,2横屏</div>
        </div>
        <el-form-item label="liveid" required>
          <el-input v-model="form.liveid" placeholder="请输入直播id"></el-input>
        </el-form-item>
        <el-form-item label="enterprise_id" required style="margin-bottom: 5px">
          <el-input v-model="form.enterprise_id" placeholder="请输入企业ID"></el-input>
        </el-form-item>
        <div class="flex-row-start-center mgt-22">
          <div style="text-align: left;margin-left: 120px">备注: 企业ID,每个企业都是固定的,通常可以从观看页地址看到的</div>
        </div>
        <el-form-item label="next" required style="margin-bottom: 5px">
          <el-input v-model="form.next" placeholder="请输入next"></el-input>
          <span class="red">横屏和竖屏的next参数不一样</span>
        </el-form-item>
        <div class="flex-row-start-center mgt-22">
          <div class="flex-row-start-center" style="text-align: left;margin-left: 120px">
            备注:
            <div class="bgc" style="width: 140px; padding: 10px 0" @click="getDetail('pc')">PC观看next明细</div>
            <div class="bgc" style="width: 140px; margin-left:20px; padding: 10px 0" @click="getDetail('app')">APP观看next明细</div>
          </div>
        </div>
        <div class="flex-row-start-center">
          <div class="bgc" style=" padding: 10px 20px" @click="pcWatch('pc')">pc观看</div>
          <div class="bgc" style=" padding: 10px 20px;margin-left: 20px" @click="pcWatch('app')">app观看</div>
          <div class="red" style="margin-left: 10px">
            注意: app观看请在浏览器的手机端开发者模式下观看
          </div>
        </div>
      </el-form>
    <!-- next明细 -->
    <el-dialog title="明细" :visible.sync="goVisible" width="70%">
      <next-detail ref="nextDetail" :baseUrl="base_url" :detailData = 'form' :type="systermType"></next-detail>
    </el-dialog>
  </div>
</template>
<script>
import nextDetail from "./nextDetail.vue"
export default {
  components:{
    nextDetail
  },
  data() {
    return {
      base_url: "",
      form: {
        testBaseUrl: "https://live.youinsh.com/saastestapi/",   // 测试环境地址
        proBaseUrl: "https://live.youinsh.com/livestreamapi/",  // 生产环境地址
        app_secret: "", // 商户密钥
        base_url: 1,   // 默认环境为测试环境
        user_id:'',   // 用户id（对接方）
        auth_token:'',  // 用户授权token
        nick_name:'',  // 昵称
        enterprise_id:'',  // 企业ID
        next:'',   // 观看页地址
        play_mode:0,   // 请选择播放模式
        liveid:'',   // 直播id
        head_image:'',  // 用户头像
      },
      goVisible:false,   // 是否next明细弹框
      time:'',
      systermType:''
    };
  },
  watch: {
     // 监听form.base_url 来判断展示的环境地址
    "form.base_url"(newVal) {
      if (newVal == 1) {
        this.base_url = "https://live.youinsh.com/saastest";
      } else if (newVal == 2) {
        this.base_url = "https://live.youinsh.com/livestream";
      }
    },
    deep: true
  },
  created() {

    if (this.form.base_url == 1) {
      this.base_url = "https://live.youinsh.com/saastest";
    }

  },
  methods: {
    // 通过userid来计算auth_token
    changeUserId(){

      if(!this.form.app_secret){
        this.$message({
          message: '请输入app_secret',
          type: 'warning'
        });
        return
      }
      if(!this.form.user_id){
        this.$message({
          message: '请输入user_id',
          type: 'warning'
        });
        return
      }
      let nowData = "";
      let date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      nowData = y +""+ m +""+ d;
      this.time = nowData   // // 获取当前年月日
      this.form.auth_token = this.$md5(this.form.app_secret + nowData + this.form.user_id);
    },

    changeBaseUrl(val) {
      this.form.base_url = val;
    },

    // 校验必填项
    validatorParams(val,type){
      let msg=''

      if(val ==1){
        if(!this.form.liveid){
          msg='请输入直播id'
        }
        if(!this.form.enterprise_id){
          msg='请输入企业id'
        }
        if(type == 'app'){
          if(!this.form.play_mode){
            msg='请选择播放模式'
          }
        }
      }

      if(val == 2){
        if(!this.form.user_id){
          msg='请输入第三方的user_id,而不是本直播平台的user_id'
        }
        if(!this.form.auth_token){
          msg='请输入auth_token'
        }
        if(!this.form.nick_name){
          msg='请输入用户昵称'
        }
        if(!this.form.head_image){
          msg='请输入用户头像'
        }
        if(!this.form.play_mode){
          msg='请选择播放模式'
        }
        if(!this.form.liveid){
          msg='请输入直播id'
        }
        if(!this.form.enterprise_id){
          msg='请输入企业id'
        }
      }

      return { msg }

    },
    getDetail(type){
      const valParams = this.validatorParams(1,type);
      if (valParams.msg != '') {
        this.$message({
          message: valParams.msg,
          type: 'warning',
          timeout: 1500,
        });
        return
      }

      let pcUrl =''

      if(type == 'pc'){
        pcUrl = this.base_url + '/pcwatch/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
      }else if(type == 'app'){
        if(this.form.play_mode == 2){
          pcUrl = this.base_url + '/watch/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
        }else if (this.form.play_mode == 1){
          pcUrl = this.base_url + '/verticalScreen/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
        }
      }

      this.form.next =encodeURIComponent(pcUrl)  // 获取next重定向直播地址

      setTimeout(() => {
        this.systermType = type
        this.goVisible = true
        this.$nextTick(()=>{
          this.$refs.nextDetail.PCUrl()
          this.$refs.nextDetail.watchAPPUrl()
          this.$refs.nextDetail.verticalScreenAPPUrl()
        })
      }, 1000);

    },

    pcWatch(type){

      const valParams = this.validatorParams(2);
      if (valParams.msg != '') {
        this.$message({
          message: valParams.msg,
          type: 'warning',
          timeout: 1500,
        });
        return
      }

      let pcUrl =''

      if(type == 'pc'){
        pcUrl = this.base_url + '/pcwatch/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
      }else if(type == 'app'){
        if(this.form.play_mode == 2){
          pcUrl = this.base_url + '/watch/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
        }else if (this.form.play_mode == 1){
          pcUrl = this.base_url + '/verticalScreen/?liveid='+this.form.liveid+'&enterprise_id='+this.form.enterprise_id
        }
      }

      this.form.next =encodeURIComponent(pcUrl)

      let url = `${this.base_url}/v1/user/watch_from_app_xcx/?user_id=${this.form.user_id}&auth_token=${this.form.auth_token}&enterprise_id=${this.form.enterprise_id}&nick_name=${this.form.nick_name}&head_image=${this.form.head_image}&next=${this.form.next}`

      window.open(url, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  text-align: center;
  width: 120px !important;
}
/deep/ .el-input {
  width: 500px;
}
/deep/ .el-upload--picture-card{
  width: 100px;
  height: 50px;
  line-height: 50px;
  border: none;
}
.token_code{
  // width: 500px;
  border:1px solid #dedede;
  padding: 10px;
}


.bgc{
  border: 1px solid #dedede;
  background: #409eff;
  padding: 10px 20px;
  color:#fff;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.watchSet {
  width: 100%;
  height: 100%;
  display: flex;

  .side-left {
    width: 150px;
    height: 100%;
    background-color: #fff;
    .side-name {
      border: 1px solid #dedede;
      text-align: center;
      padding: 20px;
      cursor: pointer;
      color: #333;
    }
  }
  .side-right {
    margin-left: 20px;
    flex: 1;
    background-color: #fff;
    padding: 10px 20px;
    overflow: scroll;
    .right-card {
      .side-url {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 20px;
        .baseurl-url {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
      }
    }
    .live-all{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .live-list{
        flex: 1;
      }
      .add-live{
        width: 80px;
        border: 1px solid #dedede;
        background: #409eff;
        padding: 10px 0;color:#fff;
        text-align: center;
        border-radius: 5px
      }
    }
    .alllive-list{
      .alllive-tab{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        .tab-one{
          padding: 0 10px;
          &:nth-child(1){
            width: 5%;
          }
          &:nth-child(2){
            width: 15%;
          }
          &:nth-child(3){
            width: 15%;
          }
          &:nth-child(4){
            width: 15%;
          }
          &:nth-child(5){
            width: 15%;
          }
        }
      }
      .alllive-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #dedede;
        .live-one{
          padding: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:nth-child(1){
            width: 5%;
          }
          &:nth-child(2){
            width: 15%;
          }
          &:nth-child(3){
            width: 15%;
          }
          &:nth-child(4){
            width: 15%;
          }
          &:nth-child(5){
            width: 15%;
          }
        }
      }

    }
    .page_box{
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/liveList/watchSet/index.vue